__turbopack_context__.v({
  "content": "o_aIfa_content",
  "slideDown": "o_aIfa_slideDown",
  "slideUp": "o_aIfa_slideUp",
});
